"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRuleMessage = getRuleMessage;
exports.getWarningMessage = getWarningMessage;
const fmoney_1 = require("../methods/fmoney");
const fnumber_1 = require("../methods/fnumber");
const lang_1 = require("../methods/lang");
const schemaMethods_1 = require("../schemaMethods");
const msgRegex = {
    minimum: /\{\{minimum\}\}/g,
    maximum: /\{\{maximum\}\}/g,
    exclusiveMaximum: /\{\{exclusiveMaximum\}\}/g,
    exclusiveMinimum: /\{\{exclusiveMinimum\}\}/g,
    multipleOf: /\{\{multipleOf\}\}/g,
    maxLength: /\{\{maxLength\}\}/g,
    minLength: /\{\{minLength\}\}/g,
    maxItems: /\{\{maxItems\}\}/g,
    minItems: /\{\{minItems\}\}/g,
    pattern: /\{\{pattern\}\}/g,
    format: /\{\{format\}\}/g,
    enum: /\{\{enum\}\}/g,
    title: /\{\{title\}\}/g,
    value: /\{\{value\}\}/g
};
const mustacheRegex = /{{\s*(\w*)\s*}}/gim; // poprzednio /{{([a-z.[]\s\?"':()\+]*)}}/gim;
function _getMessage(internal, rule, value, $schema, warning) {
    var _a, _b, _c, _d, _e, _f;
    $schema = $schema || internal.schema;
    // const i18n = internal.options.i18n;
    const i18n = (_a = internal.options._i18n) === null || _a === void 0 ? void 0 : _a.value;
    const lang = (_c = (_b = internal.options._lang) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : lang_1.defaultLang.current;
    // this._options._lang.value
    let msg = rule;
    const lmsgs = warning ? (_d = internal.schema.warnings) === null || _d === void 0 ? void 0 : _d.warningMessages : internal.schema.validationMessages;
    //najpierw sprawdz czy jest lokalnie
    if (lmsgs) {
        let msg2 = '';
        if (warning) {
            if (internal.schema.warnings) {
                if (rule === 'format' && internal.schema.warnings.format) {
                    msg2 = lmsgs['format.' + internal.schema.warnings.format];
                }
                else if (rule === 'type' && internal.schema.warnings.type) {
                    msg2 = lmsgs['type.' + internal.schema.warnings.type];
                }
            }
        }
        else {
            if (rule == 'format' && internal.schema.format) {
                msg2 = lmsgs['format.' + internal.schema.format];
            }
            else if (rule == 'type' && internal.schema.type) {
                msg2 = lmsgs['type.' + internal.schema.type];
            }
        }
        if (!msg2) {
            msg2 = lmsgs[rule];
        }
        if (msg2) {
            msg = i18n ? i18n.t(msg2) : msg2;
        }
        // const msg1 = (internal.schema.validationMessages as any)[rule];
    }
    if (i18n && msg == rule) {
        let nkey = msg;
        let msg2 = i18n.t(nkey);
        // nie ma tłumaczenia
        if (msg2 === nkey) {
            const i18prefix = warning ? 'warningMessages.' : 'validationMessages.';
            //if (msg2 === nkey) {
            const format = warning ? (_e = internal.schema.warnings) === null || _e === void 0 ? void 0 : _e.format : internal.schema.format;
            const type = warning ? (_f = internal.schema.warnings) === null || _f === void 0 ? void 0 : _f.type : internal.schema.type;
            if (rule === 'format' && format) {
                nkey = i18prefix + 'format.' + format;
                msg2 = i18n.t(nkey);
            }
            else if (rule === 'type' && type) {
                nkey = i18prefix + 'type.' + type;
                msg2 = i18n.t(nkey);
            }
            if (msg2 === nkey) {
                nkey = i18prefix + rule;
                msg2 = i18n.t(nkey);
            }
            //}
        }
        if (msg2 !== nkey) {
            msg = msg2;
        }
    }
    // teraz sprawdz czy jest w opcjach
    //const isDefaultMessage = false;
    if (msg == rule) {
        const msgs = warning ? internal.options.warningMessages : internal.options.validationMessages;
        let msg2 = '';
        //let msgKey = '';
        if (warning) {
            if (internal.schema.warnings) {
                if (rule === 'format' && internal.schema.warnings.format) {
                    msg2 = msgs['format.' + internal.schema.warnings.format];
                }
                else if (rule === 'type' && internal.schema.warnings.type) {
                    msg2 = msgs['type.' + internal.schema.warnings.type];
                }
            }
        }
        else {
            if (rule == 'format' && internal.schema.format) {
                msg2 = msgs['format.' + internal.schema.format];
            }
            else if (rule == 'type' && internal.schema.type) {
                msg2 = msgs['type.' + internal.schema.type];
            }
        }
        if (!msg2) {
            msg2 = msgs[rule];
        }
        if (msg2) {
            //isDefaultMessage = msg2 === defaultOptions.validationMessages[msgKey];
            msg = msg2;
            // msg = i18n ? i18n.t(msg2) : msg2;
        }
    }
    if (warning) {
        if (typeof internal.schema.warnings[rule] === 'number') {
            msg = msg.replace(msgRegex[rule] || 'rrr', () => internal.schema.warnings[rule] === undefined
                ? ''
                : (0, fnumber_1.fnumber)(internal.schema.warnings[rule]));
        }
    }
    else {
        if (typeof internal.schema[rule] === 'number') {
            msg = msg.replace(msgRegex[rule] || 'rrr', () => internal.schema[rule] === undefined ? '' : (0, fnumber_1.fnumber)(internal.schema[rule], undefined, lang));
        }
    }
    // zamiana {{maxLength}} na prawdziwą wartość
    return msg.replace(mustacheRegex, (match, matchrule) => {
        var _a;
        switch (matchrule) {
            case 'key':
                return internal.schema.$key || '';
            case 'title':
                return $schema.title || internal.schema.$key || '';
            case 'shortTitle':
                return $schema.shortTitle || $schema.title || internal.schema.$key || '';
            case 'format':
                return warning ? ((_a = internal.schema.warnings) === null || _a === void 0 ? void 0 : _a.format) || '' : internal.schema.format || '';
            case 'value':
                return value;
            case 'minimum':
            case 'maximum':
            case 'exclusiveMinimum':
            case 'exclusiveMaximum': {
                const svalue = warning ? $schema.warnings[matchrule] : $schema[matchrule];
                if (svalue !== undefined) {
                    if (typeof svalue === 'number') {
                        if (internal.schema.type === 'money') {
                            return (0, fmoney_1.fmoney)(svalue, undefined, undefined, lang);
                        }
                        else {
                            return (0, fnumber_1.fnumber)(svalue, undefined, lang);
                        }
                    }
                    if (internal.schema.type === 'string') {
                        // debugger;
                        switch (internal.schema.format) {
                            case 'date':
                                return (0, schemaMethods_1.displayDate)(svalue, undefined, lang);
                            // svalue.length >= 10 ? `${svalue.substring(8, 10)}.${svalue.substring(5, 7)}.${svalue.substring(0, 4)}` : svalue;
                            case 'date-time':
                                return svalue.length === 19
                                    ? (0, schemaMethods_1.displayDate)(svalue, undefined, lang) + ' ' + svalue.substring(11)
                                    : svalue.length === 10
                                        ? `${(0, schemaMethods_1.displayDate)(svalue, undefined, lang)} 00:00:00`
                                        : svalue;
                        }
                    }
                    /*
                    if (internal.schema.type === 'string' && internal.schema.format === 'date') {
                      if (svalue.length >= 10) {
                        return `${svalue.substring(8, 10)}.${svalue.substring(5, 7)}.${svalue.substring(0, 4)}`;
                      } else {
                        return svalue;
                      }
                    }
                    */
                    return svalue;
                }
                return '';
            }
            default:
                return warning ? $schema.warnings[matchrule] || '' : $schema[matchrule] || '';
        }
    });
}
/**
 * pobranie komunikatu błedu
 *
 * @export
 * @param {IInternal} internal dane wewnętrzne obiektu
 * @param {string} rule typ błedu
 * @param {*} value wartośc pola
 * @param {*} [$schema=null] schemat z wyliczonymi wartościami
 * @returns {string} komunikat błedu
 */
function getRuleMessage(internal, rule, value, $schema = null) {
    return _getMessage(internal, rule, value, $schema, false);
}
/**
 * pobranie komunikatu ostrzeżenia
 *
 * @export
 * @param {IInternal} internal dane wewnętrzne obiektu
 * @param {string} rule typ błedu
 * @param {*} value wartośc pola
 * @param {*} [$schema=null] schemat z wyliczonymi wartościami
 * @returns {string} komunikat ostrzeżenia
 */
function getWarningMessage(internal, rule, value, $schema = null) {
    return _getMessage(internal, rule, value, $schema, true);
}
exports.default = getRuleMessage;
//# sourceMappingURL=getRuleMessage.js.map